import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M13.933 20.907c-.607-.823-1.426-1.793-2.245-2.94-.819-1.146-1.637-1.91-.88-3.498.91-1.91 4.095-1.675 4.672.441.576 2.117-1.335 2-1.305 1 .03-.912 2.942-3.293 4.823-1.03 1.941 2.353-2.184 4.41-3.549 5.469-1.364 1.058-1.274.911-1.516.558Z"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M6.35 20.81c-.476-1.918-1.022-4.116-1.328-7.012s2.76-4.152 2.76-4.152a2.98 2.98 0 0 1-2.317-2.617c-.17-1.64.954-3.105 2.556-3.28s3.034 1.012 3.204 2.652a2.95 2.95 0 0 1-1.33 2.826s1.092-.418 3.035.419"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M11.396 9.855c1.738-1.256 2.863-1.081 2.863-1.081-.989-.384-1.773-1.326-1.875-2.477-.17-1.64.989-3.106 2.59-3.28 1.603-.174 3.034 1.012 3.205 2.652a3.01 3.01 0 0 1-1.738 3.07s2.01.28 3.067 1.78"
    />
  </svg>
);
export const CoupleIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
